(function () {
  'use strict';
  function createGuard({ document, window, getSmartCart }) {
    let dismissed = false, started = false;
    const bindings = new Map();
    function bind() {
      const cart = getSmartCart();
      if (!cart || typeof cart.show !== 'function') return;
      let saved = bindings.get(cart);
      if (!saved || cart.show !== saved.wrapper) {
        const original = cart.show;
        saved = { original, skipOwned: false };
        saved.wrapper = function (...args) {
          if (dismissed) return;
          return original.apply(this, args);
        };
        cart.show = saved.wrapper;
        bindings.set(cart, saved);
      }
      if (dismissed) suppress(cart, saved);
    }
    function suppress(cart, saved) {
      if (!saved.skipOwned) {
        saved.skip = cart.skip_open;
        saved.hadSkip = Object.prototype.hasOwnProperty.call(cart, 'skip_open');
        saved.skipOwned = true;
      }
      cart.skip_open = true;
    }
    function dismiss() {
      dismissed = true;
      bind();
    }
    function allow() {
      dismissed = false;
      bindings.forEach((saved, cart) => {
        if (!saved.skipOwned) return;
        if (cart.skip_open === true) {
          if (saved.hadSkip) cart.skip_open = saved.skip;
          else delete cart.skip_open;
        }
        saved.skipOwned = false;
      });
      bind();
    }
    function click(event) {
      if (event.target.closest('#cart-icon-bubble')) { allow(); return; }
      const control = event.target.closest('button[type="submit"],input[type="submit"],[name="add"]');
      if (control?.form?.matches('form[action*="/cart/add"],ds-core-set-picker form[data-set-form]') && !control.disabled) allow();
    }
    function submit(event) {
      if (event.target.matches?.('form[action*="/cart/add"],ds-core-set-picker form[data-set-form]')) allow();
    }
    function show(event) {
      if (!dismissed) { bind(); return; }
      event.stopImmediatePropagation?.();
      const cart = event.detail?.smartcart || getSmartCart();
      if (typeof cart?.hide === 'function') cart.hide();
    }
    function leave() {
      dismiss();
      const cart = getSmartCart();
      if (typeof cart?.hide === 'function') cart.hide();
    }
    function start() {
      if (started) return;
      started = true;
      document.addEventListener('click', click, true);
      document.addEventListener('submit', submit, true);
      document.addEventListener('rebuy:smartcart.hide', dismiss);
      document.addEventListener('rebuy:smartcart.show', show);
      document.addEventListener('rebuy:smartcart.ready', bind);
      document.addEventListener('rebuy:cart.ready', bind);
      window?.addEventListener('pagehide', leave);
      bind();
    }
    function destroy() {
      document.removeEventListener('click', click, true);
      document.removeEventListener('submit', submit, true);
      document.removeEventListener('rebuy:smartcart.hide', dismiss);
      document.removeEventListener('rebuy:smartcart.show', show);
      document.removeEventListener('rebuy:smartcart.ready', bind);
      document.removeEventListener('rebuy:cart.ready', bind);
      window?.removeEventListener('pagehide', leave);
      allow();
      bindings.forEach((saved, cart) => { if (cart.show === saved.wrapper) cart.show = saved.original; });
      bindings.clear();
      started = false;
    }
    return { start, destroy };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = createGuard;
  else if (!document.documentElement.dataset.dsCartDismissal) {
    document.documentElement.dataset.dsCartDismissal = 'ready';
    createGuard({ document, window, getSmartCart: () => window.Rebuy?.SmartCart }).start();
  }
}());
